import { Group } from 'fabric/fabric-impl';
import { commonPlaceholder } from 'modules/overlay-canvas/types/placeholders/create-argument';
import SnapToGrid from '../snap-to-grid';
import { BasePlaceholder, ConstructorProps } from './base';
import TeamComposition from './complex/team-composition';
import TeamPeriodFouls from './complex/team-period-fouls';

export class Complex extends BasePlaceholder {
  private teamComposition: TeamComposition;
  private teamPeriodFouls: TeamPeriodFouls;

  constructor(props: ConstructorProps) {
    super(props);
    this.teamComposition = new TeamComposition({ manager: this.manager });
    this.teamPeriodFouls = new TeamPeriodFouls({ manager: this.manager });
  }

  create(props: commonPlaceholder) {
    let placeholder: Group;

    switch (props.indicator) {
      case 'lastGameResults': {
        placeholder = this.createImagePlaceholder(props);
        SnapToGrid.snapToGrid([placeholder]);
        break;
      }
      case 'teamComposition': {
        placeholder = this.teamComposition.create();
        break;
      }
      case 'teamPeriodFouls': {
        placeholder = this.teamPeriodFouls.create();
        break;
      }
      default: {
        throw new Error('Unknown placeholder type');
      }
    }

    this.canvas.add(placeholder);
    return placeholder;
  }
}
